import { useTranslation } from 'react-i18next';

import styles from './ComingSoonStrip.module.scss';
import { Props } from './ComingSoonStrip.types';

/**
 * Compact "Bientôt disponible" band: two mini cards on one row instead of two full
 * height tiles, so the section stays reachable at the first scroll on a 1366x768
 * screen rather than sitting off screen.
 */
const ComingSoonStrip = ({ children }: Props) => {
  const { t } = useTranslation();

  return (
    <section className={styles.container}>
      <h3 className={styles.heading}>{t('expenses.home.comingSoon', 'Bientôt disponible')}</h3>
      <div className={styles.grid}>{children}</div>
    </section>
  );
};

export default ComingSoonStrip;
